import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@shared/translate/translate.service';
import {
  ConfigurationId,
  SwitchProps,
  SwitchState,
  ToggleOption,
  ToggleProps,
  TogglePropsOption,
} from '@types';

export interface CalcTypeComponent {
  updateCalcType: (value: string | ToggleOption) => void;
}

export interface CalcTypeGroupHeaderParams {
  parentComponent: CalcTypeComponent;
  configurationName: string;
  calcType: string | ToggleProps;
}

@Component({
  selector: 'ft-calc-type-group-header',
  templateUrl: './calc-type-group-header.component.html',
  styleUrls: ['./calc-type-group-header.component.scss'],
})
export class CalcTypeGroupHeaderComponent implements OnChanges {
  @Input() params: CalcTypeGroupHeaderParams; // this (using ngOnchanges) allows the switch to be used as a normal component in card view
  parentComponent: CalcTypeComponent;
  switchProps: SwitchProps;
  configurationId: string;
  toggleButtons: ToggleOption[] = [];
  label = '';
  private calcOptions: ToggleProps;

  constructor(private translateService: TranslateService) {}

  ngOnChanges() {
    if (this.params) {
      this.agInit(this.params);
    }
  }

  agInit(params: CalcTypeGroupHeaderParams) {
    this.parentComponent = params.parentComponent;

    // Match the configuration name to available Configuration IDs,
    // and, assign the same, to render the corresponding template.
    this.configurationId = Object.keys(ConfigurationId).find(
      (configurationId: string) =>
        ConfigurationId[configurationId] === params.configurationName
    );

    // Assign, in case present in params, accordingly.

    const calcType = params.calcType;

    if (typeof calcType !== 'string') {
      const calcOptions = calcType as ToggleProps;
      this.calcOptions = calcOptions;
      if (calcOptions.labelKey) {
        this.label = this.translateService.instant(calcOptions.labelKey);
      }
      if (calcOptions.type === 'toggle') {
        this.toggleButtons = []; // reset array, as ngOnChanges() can be called more than once
        calcOptions.options.forEach((option: TogglePropsOption) => {
          this.toggleButtons.push({
            active: option.value === calcOptions.selected,
            text: this.translateService.instant(option.label),
            value: option.value,
          });
        });
      } else if (
        calcOptions.type === 'switch' &&
        calcOptions.options.length > 1
      ) {
        this.switchProps = {
          labelKey: calcOptions.labelKey,
          labelOffKey: calcOptions.options[0].label,
          labelOnKey: calcOptions.options[1].label,
          state:
            calcOptions.options[0].value === calcOptions.selected
              ? SwitchState.OFF
              : SwitchState.ON,
        };
      }
    }
  }

  onSwitchPressed(state: string) {
    this.parentComponent.updateCalcType(
      state === SwitchState.OFF
        ? this.calcOptions.options[0].value
        : this.calcOptions.options[1].value
    );
  }

  onToggleActive(selectedOption: ToggleOption) {
    this.parentComponent.updateCalcType(selectedOption.value);
  }
}
